export default __webpack_public_path__ + "assets/67576f4b9e79539ff876e591a1f37a11.png";